import EventEmitter from "./utils/EventEmitter";
import AccordionFilters from "./form/AccordionFilters";
import RangePeriod from "./form/RangePeriod";

export default class SearchPage extends EventEmitter {
    constructor(element) {
        super();

        this.el = element;

        this.filtersWrapper = this.el.querySelector('.search-filters-wrapper');
        this.tabsButtons = this.el.querySelectorAll('.tabs-buttons-container .tab-button');
        this.accordionElms = this.el.querySelectorAll('.accordion');
        this.periodFilters = this.el.querySelector('.range-period-wrapper');
        this.authorsFilter = this.el.querySelector('.authors-filter');
        this.mobileFiltersButton = this.el.querySelector('.mobile-filter-button');
        this.mobileFilterCross = this.filtersWrapper.querySelector('.cross');
        this.form = this.filtersWrapper.querySelector('form');

        if (this.accordionElms.length > 0) {
            this.initAccordions()
        }

        if (this.periodFilters) {
            this.initPeriodFilters()
        }

        if (this.authorsFilter) {
            this.initAuthorsFilter()
        }

        this.mobileControls()
    }

    mobileControls() {
        this.mobileFiltersButton.addEventListener('click', () => {
            if (this.mobileFiltersButton.classList.contains('is-filters-open')) {
                this.form.submit()
            }
            this.filtersWrapper.classList.add('is-open')
            this.mobileFiltersButton.classList.add('is-filters-open')
            this.mobileFiltersButton.querySelector('p').innerText = this.mobileFiltersButton.dataset.apply
        })

        this.mobileFilterCross.addEventListener('click', () => {
            this.filtersWrapper.classList.remove('is-open')
            this.mobileFiltersButton.classList.remove('is-filters-open')
            this.mobileFiltersButton.querySelector('p').innerText = this.mobileFiltersButton.dataset.open
        })

    }

    initAccordions() {
        // Si on avait déjà des accordions, on supprime les instances
        if (this.accordions) {
            this.accordions.forEach((accordion) => {
                accordion.destroy()
            })
        }

        if (this.accordionsAuthors) {
            this.accordionsAuthors.destroy()
        }

        this.accordions = []
        this.accordionsAuthors = null

        this.accordionElms.forEach((accordion) => {
            if (accordion.classList.contains('authors-filter')) {
                this.accordionsAuthors = new AccordionFilters(accordion)
            } else {
                const a = new AccordionFilters(accordion)
                this.accordions.push(a)
            }
        })
    }

    initPeriodFilters() {
        new RangePeriod(this.periodFilters)
    }

    initAuthorsFilter() {
        const input = this.authorsFilter.querySelector('input')
        const list = this.authorsFilter.querySelectorAll('.accordion-content .form-item')

        input.addEventListener('input', () => {

            if (input.value === '') {
                this.accordionsAuthors.close()
                return
            }

            const value = input.value.toLowerCase()
            list.forEach((item) => {
                const text = item.querySelector('label').textContent.toLowerCase()

                if (text.includes(value)) {
                    item.style.display = 'flex'
                } else {
                    item.style.display = 'none'
                }
            })

            setTimeout(() => {
                if (this.accordionsAuthors) {
                    this.accordionsAuthors.updateHeight()
                }
            }, 100)
        })
    }

}
